import {Component, EventEmitter, OnInit, Output, Input} from '@angular/core';
import {CompanyService} from '../../company/company.service';
import {CountryService} from '../../country/country.service';
import {Model} from '../../app.model';
import {AutorunComponent} from '@myshared/autorun.component';
import {Company} from '../../company/company.model';
import {Country} from "../../country/country.model";
import {FormEmitter} from "../../forms/form.component";

@Component({
    selector: 'app-invoice-address',
    templateUrl: './invoice-address.component.html',
    styleUrls: [],
    standalone: false
})
export class InvoiceAddressComponent extends AutorunComponent implements OnInit {

  @Input() public validateViaApi = false;
  @Input() public backLabel = 'app_back';
  @Input() public historyBack = true;
  @Input() public company?: Company;
  @Input() public onlyEmit = false;

  @Output() public backEvent = new EventEmitter();
  @Output() public readonly next = new EventEmitter<Company>();

  countries: Country[] = [];

  constructor(private m: Model,
              private countryService: CountryService,
              private companyService: CompanyService) {
    super();
  }

  ngOnInit() {
    this.countryService.refresh();
    if (!this.company) {
      this.companyService.refresh(true);
    }

    this.autorun(() => {
      this.countries = this.m.country.countries;
      if (!this.company?.id) {
        this.company = this.m.company.company;
      }
    });

  }

  onNext(form: FormEmitter<Company>) {
      const company = form.data;

      if (this.validateViaApi) {
        company.validate_address = true;
      }

      // When we want to only get back the company from form without API call
      if (this.onlyEmit) {
        this.next.emit(company);
        return;
      }

      this.companyService.update(company).subscribe((resCompany: Company) => {
        this.next.emit(resCompany);
      });
  }

  public onBack() {
    this.backEvent.emit();
  }

}
